import { isIOS } from '../utils';

type Data = {
    name: string;
    phoneNumber: string;
    redeemHash: string;
};

type BasicData = Pick<Data, 'name' | 'redeemHash'>;

const { protocol, host } = window.location;
const redeemBaseUrl = `${protocol}//${host}/redeem`;

const buildRedeemUrl = (hash: string) => `${redeemBaseUrl}?hash=${hash}`;

const buildMessageText = (name: string, url: string) => [
    `Olá ${name},`,
    'Você recebeu um Ticketx da Flix Media.',
    `Acesse o link para resgatar: ${url}`
].join('\n');

const buildWhatsappLink = (phoneNumber: string, message: string) => {
    const formattedPhone = `55${phoneNumber.replace(/[^0-9]/g, '')}`;
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
};

const shareDistributionToRecipient = ({ name, phoneNumber, redeemHash }: Data) => {
    const redeemUrl = buildRedeemUrl(redeemHash);
    const message = buildMessageText(name, redeemUrl);
    const whatsappLink = buildWhatsappLink(phoneNumber, message);
		if (isIOS()) {
				window.location.href = whatsappLink;
				return;
		}
		window.open(whatsappLink, '_blank', 'noopener,noreferrer');
};

const shareDistributionNative = async ({ name, redeemHash }: BasicData): Promise<'shared' | 'copied' | 'error' | 'aborted'> => {
    const redeemUrl = buildRedeemUrl(redeemHash);
    const message = buildMessageText(name, redeemUrl);

    const shareData = {
        text: `Olá ${name},\nVocê recebeu um Ticketx da Flix Media.\nAcesse o link para resgatar:`,
        url: redeemUrl
    };

    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    const isStandalone = 'standalone' in window.navigator && (window.navigator as any).standalone;
    const delayShare = isIOS() && isStandalone;

    try {
        if (delayShare) {
            await delay(200);
        }

        await navigator.share(shareData);
        return 'shared';
    } catch (err: any) {
        if (err.toString().includes('AbortError')) 
            return 'aborted';
        try {
            await navigator.clipboard.writeText(message);
            return 'copied';
        } catch {
            return 'error';
        }
    }
};


export { 
    shareDistributionToRecipient,
    shareDistributionNative,
};
